export default {
   primary: '#0e1d48',
   secondary: '#00bcbd',
   borderColor: '#E5E5E5',
   grayBorder: '#9F9F9F',
   gray: '#F7F7F7',
   lightRed: '#FFD3D3',
   lighYellow: '#ffdb69',
   doneGreen: '#65be3e',
   doneRed: '#f97557',

   lighGreen: '#dcfce7',
   lightBlue: '#e6e7ec',
   lightGray: '#e6e7eb',

   green: '#47df82',
   red: '#f6726d',
   gray_: '#9da2ad',

   boldGreen: '#2d6f4a',
   boldRed: '#79393f',
   boldGray: '#5f636b',

   facebookBlue: '#0866FF',
};
